// Fetch-Wrapper für die Self-Service-Endpunkte (Termin ansehen/absagen/
// umbuchen per manage_token). Gleiches Muster wie bookingPublicApi.ts:
// unauthentifiziert, Cross-Origin von seadent.es zum Admin-Backend.

const API_BASE_URL = process.env.NODE_ENV === 'production'
    ? 'https://admin.seadent.es/api'
    : 'http://localhost:5000/api';

export interface ManagedAppointment {
    patient_name: string;
    appointment_date: string;  // 'YYYY-MM-DD'
    start_time: string;        // 'HH:mm'
    end_time: string;
    status: 'pending' | 'scheduled' | 'confirmed' | 'cancelled' | 'completed' | 'no_show';
    language: string;
    provider_name: string;
    procedure_name: string;
}

export interface ManagePolicy {
    canCancel: boolean;
    canReschedule: boolean;
    reason: 'disabled' | 'status' | 'past' | null;
    hoursUntil: number;
    cancelMinHours: number;
    rescheduleMinHours: number;
    reschedulesRemaining: number;
}

export interface ManageLoadResponse {
    appointment: ManagedAppointment;
    policy: ManagePolicy;
}

export interface ManageDay {
    date: string;
    hasSlots: boolean;
    count: number;
}

export interface ManageSlot {
    start_time: string;
    end_time: string;
}

// Fehler mit Server-Code (z. B. 'slot_taken'), damit die UI gezielt reagieren kann.
export class SelfserviceError extends Error {
    code?: string;
    status: number;
    constructor(message: string, status: number, code?: string) {
        super(message);
        this.status = status;
        this.code = code;
    }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
    const r = await fetch(`${API_BASE_URL}/public/appointment/${path}`, init);
    let body: any = null;
    try { body = await r.json(); } catch { /* leerer Body */ }
    if (!r.ok || !body || body.success === false) {
        throw new SelfserviceError(body?.message || `Request failed: ${r.status}`, r.status, body?.code);
    }
    return body as T;
}

export function loadManagedAppointment(token: string): Promise<ManageLoadResponse> {
    return request<ManageLoadResponse>(encodeURIComponent(token));
}

export function cancelAppointment(token: string): Promise<{ appointment: ManagedAppointment }> {
    return request(`${encodeURIComponent(token)}/cancel`, { method: 'POST' });
}

export async function getManageAvailability(token: string, from: string, to: string): Promise<ManageDay[]> {
    const r = await request<{ days: ManageDay[] }>(
        `${encodeURIComponent(token)}/availability?from=${from}&to=${to}`
    );
    return Array.isArray(r.days) ? r.days : [];
}

export async function getManageSlots(token: string, date: string): Promise<ManageSlot[]> {
    const r = await request<{ slots: ManageSlot[] }>(
        `${encodeURIComponent(token)}/slots?date=${date}`
    );
    return Array.isArray(r.slots) ? r.slots : [];
}

export function rescheduleAppointment(token: string, date: string, time: string): Promise<ManageLoadResponse> {
    return request(`${encodeURIComponent(token)}/reschedule`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ date, time }),
    });
}
